import { createContext, useContext } from 'react';
import { EmailThreadContextType } from './types';

// Kept in its own module (separate from index.tsx/EmailThreadModal.tsx) to avoid
// a circular import between the provider and its consumers, which breaks Vite
// Fast Refresh and causes stray "must be used within a Provider" errors on HMR.
export const EmailThreadContext = createContext<
  EmailThreadContextType | undefined
>(undefined);

export function useEmailThread() {
  const context = useContext(EmailThreadContext);
  if (context === undefined) {
    throw new Error(`useEmailThread must be used within a EmailThreadProvider`);
  }

  return context;
}
